import * as React from "react"

// Improved mobile breakpoints for more granular control
const MOBILE_BREAKPOINT = 768
const SMALL_MOBILE_BREAKPOINT = 480 

export interface MobileState {
  isMobile: boolean
  isSmallMobile: boolean
  isPortrait: boolean
  width: number
}

export function useIsMobile(): MobileState {
  // SSR-safe: Always start with safe defaults, never access window during render
  const [state, setState] = React.useState<MobileState>({
    isMobile: false,
    isSmallMobile: false,
    isPortrait: true,
    width: 0
  })

  React.useEffect(() => {
    // Only access window APIs in useEffect (client-side only)
    if (typeof window === 'undefined') return;

    // Handle both screen size and orientation changes
    const handleResize = () => {
      if (typeof window === 'undefined') return;
      const width = window.innerWidth
      const height = window.innerHeight
      setState({
        isMobile: width < MOBILE_BREAKPOINT,
        isSmallMobile: width < SMALL_MOBILE_BREAKPOINT,
        isPortrait: height > width,
        width
      })
    }
    
    // Create media queries for different breakpoints
    const mobileMql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const smallMobileMql = window.matchMedia(`(max-width: ${SMALL_MOBILE_BREAKPOINT - 1}px)`)
    const orientationMql = window.matchMedia('(orientation: portrait)')
    
    // Setup event listeners
    mobileMql.addEventListener("change", handleResize)
    smallMobileMql.addEventListener("change", handleResize)
    orientationMql.addEventListener("change", handleResize)
    
    // Set initial value
    handleResize()
    
    // Cleanup
    return () => {
      mobileMql.removeEventListener("change", handleResize)
      smallMobileMql.removeEventListener("change", handleResize)
      orientationMql.removeEventListener("change", handleResize)
    }
  }, [])

  return state
}
